import React, { useEffect, useState } from "react";
import { makeActiveObject } from "../create/saveObjects";
import { updatePlayerAttribute } from "../firebase/fireFuncs";
import useHandleOpenObject from "../hooks/useHandleOpenObject";
import { forArrayLength } from "../misc/helperfuncs";
import MainStore from "../stores/MainStore";
import DropArea from "./DropArea";
import useHandleActiveGoal from "./../hooks/useHandleActiveGoal";

const DropAreas = ({ setShowActiveGoal, setShowActiveActivity }) => {
  const { dragCursor, setDragCursor, setHideCursor, setActiveGoal, player } =
    MainStore();

  const handleActive = useHandleActiveGoal();

  const handleOpenObject = useHandleOpenObject({
    onOpened,
    objects: dragCursor.objects,
    onBack: () => {
      setDragCursor(null);
      setHideCursor(false);
    },
  });

  function onOpened(openObject) {
    const activeObject = makeActiveObject(openObject);
    handleActive(activeObject);
    setShowActiveGoal(true);
    setDragCursor(null);
    setHideCursor(false);
  }

  function handleActiveGoal() {
    if (dragCursor.objects.open) onOpened(dragCursor.objects.open);
    else handleOpenObject.open();
  }

  function onMouseUp(area) {
    setHideCursor(true);
    if (area == "makeActiveGoal") handleActiveGoal();
  }

  return (
    <div
      style={{
        width: "100%",
        height: "100vh",
        display: "flex",
        flexDirection: "row",
      }}
    >
      <div
        onMouseUp={() => {
          setHideCursor(false);
          setDragCursor(null);
        }}
        style={{
          width: "100%",
          height: "100vh",
          display: "flex",
          position: "fixed",
          flexDirection: "row",
        }}
      />
      {dragCursor?.type == "goal" && (
        <div
          style={{
            width: "100%",
            height: "100vh",
            display: "flex",
            flexDirection: "row",
          }}
        >
          <DropArea
            onMouseUp={onMouseUp}
            color={"lightBlue"}
            positionTop={0}
            width="25%"
            height="200px"
            positionRight={"50%"}
            topBottom={true}
            textColor="#363636"
            text={"Make Active Goal"}
            fontSize="30px"
            area="makeActiveGoal"
          />
          <DropArea
            onMouseUp={onMouseUp}
            color={"lightBlue"}
            positionTop={"12%"}
            width="200px"
            height="25%"
            positionRight={"0%"}
            topBottom={false}
            textColor="#363636"
            text={"Add to Open Goals"}
            fontSize="30px"
            area="addToOpenGoals"
          />

          <DropArea
            onMouseUp={onMouseUp}
            color={"lightBlue"}
            positionTop={"50%"}
            width="200px"
            height="25%"
            positionRight={"0%"}
            topBottom={false}
            textColor="#363636"
            text={"Save Goal for later"}
            fontSize="30px"
            area="saveInSavedGoals"
          />
          {handleOpenObject.modal}
        </div>
      )}
    </div>
  );
};

export default DropAreas;
